/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "schedule-order-for-delivery",
	props:{
		orderId:{
			default: null
		},
		orderDeliveryId: {
			default: null
		},
		orderDeliveryScheduleId:{
			default: null
		}
	},
	data() {
		return {
			order: {},
			orderGrandTotal: 0,
			billingAddress:null,
			shippingAddress: null,
			totalForOrder: 0,
			scheduleOrder:{
				orderDeliveryScheduleId: null,
				vehicleId: {
					value: null,
					errorMessage: null,
					hasError: false
				},
				driverId: {
					value: null,
					errorMessage: null,
					hasError: false
				},
				dateOfDeparture: {
					value: null,
					errorMessage: null,
					hasError: false
				},
				expectedDateOfDelivery: {
					value: null,
					errorMessage: null,
					hasError: false
				},
				sbo: {
					value: null,
					errorMessage: null,
					hasError: false
				}
			},
			initialiseDate: true,
			initialiseExpectedDate: true,
			vehicles: [],
			drivers: [],
			schedulingOrder: false,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Quantity/Litres",
					field: "quantity"
				},
				// {
				// 	text: "Amount Dispensed",
				// 	field: "quantityDispensed"
				// },
				{
					text: "Total",
					field: "totalAsString"
				},
				// {
				// 	text: "Total Price Dispensed",
				// 	field: "totalDispensedAsString"
				// }
			],
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null,
			successModal:{
				modalHeading: "Order Scheduled For Delivery Successfully",
				modalMessage: null,
				elementId: "scheduleOrderSuccessModal",
				showModal: false
			}
		};
	},
	methods: {
		getOrder(){
			this.loading = true;
			orderService.getOrderForDelivery(this.orderId, this.orderDeliveryId).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.order = successResponse.data.result;
						this.order = dataTableHelper.castObjectValues(this.order);
						//this.order.orderItems = dataTableHelper.castObjectValues(this.order.orderItems);
						// for(let i = 0; i < this.order.orderItems.length; i++){
						// 	this.order.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].unitPrice);
						// 	this.order.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalAmount);
						// 	//this.order.orderItems[i].totalDispensedAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalPriceDispensed);
						// 	//this.order.total += this.order.orderItems[i].total;
						// }
						this.order.totalAsString = currencyHelper.numberToCurrency(this.order.totalAmount);
						this.orderGrandTotal = this.order.totalAmount;
						if(this.order.discountedAmount !== null && this.order.discountedAmount > 0) {
							this.orderGrandTotal = this.order.totalAmount - this.order.discountedAmount;
						}
						this.orderGrandTotal = currencyHelper.numberToCurrency(this.orderGrandTotal);
						console.log("order", this.order);
						this.setBreadcrumbs();
						this.getCustomerShippingAddresses();
						this.getCustomerBillingAddress();
						if (this.order.orderDeliveryScheduleId !== null && this.order.orderDeliveryScheduleId > 0) {
							this.scheduleOrder.orderDeliveryScheduleId = this.order.orderDeliveryScheduleId;
							this.getOrderDeliverySchedule();
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderDeliverySchedule(){
			this.loading = true;
			console.log("orderDeliveryScheduleId", this.scheduleOrder.orderDeliveryScheduleId)
			//if(this.orderDeliveryScheduleId !== null){
				orderService.getOrderDeliverySchedule(this.scheduleOrder.orderDeliveryScheduleId, this.orderDeliveryId).then(
					successResponse =>{
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							this.scheduleOrder.vehicleId.value = successResponse.data.result.vehicleId;
							this.scheduleOrder.driverId.value = successResponse.data.result.driverId;
							
							this.scheduleOrder.sbo.value = successResponse.data.result.sbo;
							var self = this;
							setTimeout(function () {
								self.scheduleOrder.dateOfDeparture.value = successResponse.data.result.departureDate;
								self.scheduleOrder.expectedDateOfDelivery.value = successResponse.data.result.expectedDeliveryDate;
							}, 500);
						}
						this.loading = false;
					},
					errorResponse => {
						console.log("error", errorResponse);
						this.loading = false;
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				);
			//}
		},
		getCustomerShippingAddresses(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.shippingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.billingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getVehicles(){
			let request = {
				isActive: true
			};
			systemService.getAllVehicles(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.vehicles = successResponse.data.result;
						this.vehicles = $.map(this.vehicles,
							function (obj) {
								obj.id = obj.id || obj.vehicleId;
								obj.text = obj.text || obj.fleetNumber;
								return obj;
							});
						// if((this.vehicles !== null && this.length > 0) && (this.drivers !== null && this.drivers.length > 0)){
						// 	this.getOrderDeliverySchedule();
						// }
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDrivers(){
			let request = {
				isActive: true
			};
			systemService.getAllDrivers(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.drivers = successResponse.data.result;
						this.drivers = $.map(this.drivers,
							function (obj) {
								obj.id = obj.id || obj.driverId;
								obj.text = obj.text || obj.firstName + " " + obj.lastName + "(" + obj.driverId + ")";
								return obj;
							});
						// if((this.vehicles !== null && this.length > 0) && (this.drivers !== null && this.drivers.length > 0)){
						// 	this.getOrderDeliverySchedule();
						// }
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onVehicleSelect(vehicle){
			console.log("vehicle", vehicle);
			//get default driver for selected vehicle only if there is no driver selected
			if(this.scheduleOrder.driverId.value === null || this.scheduleOrder.driverId.value === 0){
				for(let i = 0; i < this.vehicles.length; i++){
					if(this.vehicles[i].vehicleId === vehicle.id){
						this.scheduleOrder.driverId.value = this.vehicles[i].defaultDriverId;
						break;
					}
				}
			}
			
			this.scheduleOrder.vehicleId.value = vehicle.id;
		},
		onDriverSelect(driver){
			this.scheduleOrder.driverId.value = driver.id;
		},
		onDateOfDepartureSelect(date){
			console.log("date", date);
			this.scheduleOrder.dateOfDeparture.value = date;
			this.initialiseDate = false;
		},
		onExpectedDateOfDeliverySelect(date){
			this.scheduleOrder.expectedDateOfDelivery.value = date;
			this.initialiseExpectedDate = false;
		},
		validateScheduleOrderForDeliverySubmit(){
			var hasError = false;
			if(this.scheduleOrder.vehicleId.value == null){
				this.scheduleOrder.vehicleId.hasError = true;
				this.scheduleOrder.vehicleId.errorMessage = "Vehicle is required";
				hasError = true;
			}
			else{
				this.scheduleOrder.vehicleId.hasError = null;
				this.scheduleOrder.vehicleId.errorMessage = null;
			}
			
			if(this.scheduleOrder.driverId.value === null){
				this.scheduleOrder.driverId.hasError = true;
				this.scheduleOrder.driverId.errorMessage = "Driver is required";
				hasError = true;
			}
			else{
				this.scheduleOrder.driverId.hasError = null;
				this.scheduleOrder.driverId.errorMessage = null;
			}
			
			if(this.scheduleOrder.expectedDateOfDelivery.value === null || this.scheduleOrder.expectedDateOfDelivery.value === ""){
				this.scheduleOrder.expectedDateOfDelivery.hasError = true;
				this.scheduleOrder.expectedDateOfDelivery.errorMessage = "Expected Date of Delivery is required";
				hasError = true;
			}
			else{
				this.scheduleOrder.expectedDateOfDelivery.hasError = null
				this.scheduleOrder.expectedDateOfDelivery.errorMessage = null;
			}
			
			if(this.scheduleOrder.dateOfDeparture.value === null || this.scheduleOrder.dateOfDeparture.value === ""){
				this.scheduleOrder.dateOfDeparture.hasError = true;
				this.scheduleOrder.dateOfDeparture.errorMessage = "Date of Departure is required";
				hasError = true;
			}
			else{
				this.scheduleOrder.dateOfDeparture.hasError = null;
				this.scheduleOrder.dateOfDeparture.errorMessage = null;
			}
			
			if(!hasError){
				this.scheduleOrderForDelivery();
			}
		},
		scheduleOrderForDelivery(){
			this.schedulingOrder = true;
			let request = {
				orderId: this.orderId,
				vehicleId: this.scheduleOrder.vehicleId.value,
				driverId: this.scheduleOrder.driverId.value,
				expectedDateOfDelivery: this.scheduleOrder.expectedDateOfDelivery.value,
				dateOfDeparture: this.scheduleOrder.dateOfDeparture.value,
				sbo: this.scheduleOrder.sbo.value,
				orderDeliveryScheduleId: this.scheduleOrder.orderDeliveryScheduleId === null || this.scheduleOrder.orderDeliveryScheduleId === "" ? 0 : this.scheduleOrder.orderDeliveryScheduleId,
				orderDeliveryId: this.orderDeliveryId,
				companyId: this.order.companyId
			};
			orderService.scheduleOrderForDelivery(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.scheduleOrderValidationResponse.valuesAreValid){
							this.schedulingOrder = false;
							this.successModal.showModal = true;
							this.successModal.modalMessage = "Order Scheduled Successfully";
							this.successModal.modalHeading = "Success";
						}
						else{
							this.scheduleOrder.dateOfDeparture.hasError = successResponse.data.scheduleOrderValidationResponse.dateOfDepartureValidationResponse.hasError;
							this.scheduleOrder.dateOfDeparture.errorMessage = successResponse.data.scheduleOrderValidationResponse.dateOfDepartureValidationResponse.message;

							this.scheduleOrder.expectedDateOfDelivery.hasError = successResponse.data.scheduleOrderValidationResponse.expectedDateOfDeliveryValidationResponse.hasError;
							this.scheduleOrder.expectedDateOfDelivery.errorMessage = successResponse.data.scheduleOrderValidationResponse.expectedDateOfDeliveryValidationResponse.message;
						}
					}
					this.schedulingOrder = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.schedulingOrder = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onSuccessModalOkClick(){
			this.successModal.showModal = false;
			this.$router.go(-1);
		},
		setBreadcrumbs() {
			var pageTitle = "Schedule Order For Delivery - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		//this.setBreadcrumbs();
		// this.getProvinces();
		// this.getShippingAreas();
		// this.getShippingZones();
		this.getVehicles();
		this.getDrivers();
	},
	watch:{
		orderId:{
			handler: function () {
				console.log("orderId", this.orderId);
				if (this.orderId !== null && this.orderId > 0) {
					this.getOrder();
				}
			},
			immediate: true,
			deep: true
		},
		// orderDeliveryScheduleId: {
		// 	handler: function () {
		// 		console.log("orderDeliveryScheduleId", this.orderDeliveryScheduleId);
		// 		if (this.orderDeliveryScheduleId) {
		// 			this.getOrderDeliverySchedule();
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// }
	}
};